export default __webpack_public_path__ + "static/media/char_body_prem_003.e9c5d4dd.png";